import React from "react";

const PersonalAccountIcon = () => {
  return (
    <svg
      className={"mt-[-3px]"}
      width="16"
      height="22"
      viewBox="0 0 16 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.3211 12.012C13.3275 12.6192 14 13.6935 14 14.9058V18.2C14 18.8273 13.4606 19.3411 12.8021 19.3411H3.75843C3.09995 19.3411 2.56055 18.8273 2.56055 18.2V14.9058C2.56055 13.6913 3.23304 12.6192 4.23945 12.012C5.30891 12.9306 6.72629 13.4911 8.27911 13.4911C9.83192 13.4911 11.2493 12.9328 12.3188 12.012M8.28144 4C10.4507 4 12.209 5.67491 12.209 7.74129C12.209 9.80767 10.4507 11.4826 8.28144 11.4826C6.11217 11.4826 4.35387 9.80767 4.35387 7.74129C4.35387 5.67491 6.11217 4 8.28144 4Z"
        fill="#303544"
      />
    </svg>
  );
};

export default PersonalAccountIcon;
